import { AnchorLink } from 'components/anchorLink';
import { Card } from '../components/card';
import { DynamicImage } from 'components/Image';
import classNames from 'classnames';
import { isNotEmpty } from 'utility/functions';
import styles from './SportNewsCard.module.scss';

export type SportNewsCardProp = {
  title: string;
  link: string;
  category: string;
  description: string;
  image: {
    src: string | null | undefined;
    alt: string | null | undefined;
  };
  containerClass?: string;
};
export const SportNewsCard = ({ title, link, category, description, image, containerClass }: SportNewsCardProp) => {
  const { alt, src } = image ?? {};
  return (
    <Card containerClass={containerClass}>
      <div className={styles.imageContainer}>
        {isNotEmpty(src) ? (
          <DynamicImage src={src!} alt={alt ?? ''} className={styles.image} fill loading="lazy" decoding="async" />
        ) : (
          <div className={classNames(styles.image, styles['image-border'])} />
        )}
        <strong className={styles.category} suppressHydrationWarning>
          {category}
        </strong>
      </div>
      <AnchorLink href={link} className={styles.linkWrapper}>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.textContent}>{description}</p>
      </AnchorLink>
    </Card>
  );
};
